import { AppModule } from 'app/module';
import { CompanyCard } from 'module/companyCard/main';
import { Slider } from 'module/slider/main';
import { mediaQueries } from 'util/mediaQueries';
import { buildUrl } from 'util/url';
import './styles.scss';

export class CompanyCardSlider extends AppModule {
    domBindings() {
        return {
            slider: '.m-slider',
            companyCards: ['.m-companyCardSlider__company .m-companyCard'],
        };
    }

    domEvents() {
        mediaQueries.events.on('changed', () => {
            if (!mediaQueries.isDesktop()) {
                this.initSlider();
            } else {
                this.destroySlider();
            }
        });
    }

    subs() {
        if (!mediaQueries.isDesktop()) {
            this.initSlider();
        }

        this.companyItems = [];
        for (let i = 0; i < this.dom.companyCards.length; i += 1) {
            this.companyItems.push(new CompanyCard(this.dom.companyCards[i]));
        }
    }

    initSlider() {
        if (!this.slider) {
            this.slider = new Slider(this.dom.slider);
            this.slider.setup();
        }
    }

    destroySlider() {
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    subEvents() {
        for (let i = 0; i < this.companyItems.length; i += 1) {
            this.companyItems[i].events.on(
                'changedCompanyTag',
                (searchRequest) => {
                    window.location.href = buildUrl(`/a?keywords=${searchRequest.arguments[0].keywords}`);
                },
            );
            this.companyItems[i].events.on(
                'changedCompanyLocation',
                (searchRequest) => {
                    window.location.href = buildUrl(`/a/${searchRequest.arguments[0].locationSlug}`);
                },
            );
        }
    }
}
